//import library
import "jquery-confirm";
import "jquery-confirm/css/jquery-confirm.css";

export default {
  init(title, content, confirmFunc) {
    $.confirm({
      title,
      content,
      buttons: {
        confirm: {
          text: "Evet",
          btnClass: "btn-success",
          keys: ["enter"],
          action: () => {
            confirmFunc();
          },
        },
        cancel: {
          escapeKey: true,
          text: "Hayır",
          btnClass: "btn-warning",
          keys: ["esc"],
          action: function () {
            this.close();
          },
        },
      },
    });
  },
};
